import { computed, Injectable, signal } from '@angular/core';
import { DashboardWidget } from './dashboard-widget.model';

/**
 * Collects {@link DashboardWidget} values registered by feature libraries
 * so the Home page can render views without importing those libraries.
 */
@Injectable({ providedIn: 'root' })
export class DashboardWidgetRegistryService {
  private readonly _widgets = signal<DashboardWidget[]>([]);

  /** Registered widgets sorted by {@link DashboardWidget.order} then id. */
  readonly widgets = computed(() =>
    [...this._widgets()].sort((a, b) => {
      const orderA = a.order ?? 0;
      const orderB = b.order ?? 0;
      if (orderA !== orderB) {
        return orderA - orderB;
      }
      return a.id.localeCompare(b.id);
    }),
  );

  /**
   * Registers or replaces a widget. Duplicate `id` values overwrite the prior entry.
   *
   * @param widget View metadata plus the standalone component to project.
   */
  register(widget: DashboardWidget): void {
    this._widgets.update((list) => {
      const without = list.filter((entry) => entry.id !== widget.id);
      return [...without, widget];
    });
  }
}
